import RandomString from "randomstring";
import Session from "./Session";

class ParticipantService {
    _get = (key) => {
        if (localStorage && localStorage.getItem(key))
            return (JSON.parse(localStorage.getItem(key)) || null);
        if (sessionStorage && sessionStorage.getItem(key))
            return (JSON.parse(sessionStorage.getItem(key)) || null);
        return (null);
    }
    _set = (key, value, isLocalStorage = true) => {
        if (isLocalStorage && localStorage)
            return (localStorage.setItem(key, JSON.stringify(value)));
        if (sessionStorage)
            return (sessionStorage.setItem(key, JSON.stringify(value)));
        console.warn('Cannot set either local and session browser storage');
        return (null);
    }
    _del = (key, isLocalStorage = true) => {
        if (isLocalStorage && localStorage)
            return (localStorage.removeItem(key));
        if (sessionStorage)
            return (sessionStorage.removeItem(key));
        return (null);
    }

    /**
     * Create a participant
     * Generate a unique id for participant and the given session id
     * Store it in the localstorage and databse
     */
    createForSession = (sessionId, participantInfos, author) => {
        const id = RandomString.generate(32);
        const infos = { id, infos: participantInfos };
        this._set(sessionId, infos);
    
        // Récupère le nom du participant
        const participantName = infos.infos.name;
        const participantId = infos.id;
        // Appelle la méthode handleNewParticipant de Session si l'utilisateur a rentré son pseudo
        if (participantName && participantId){
        Session.handleNewParticipant(participantName, participantId, sessionId, author);
        }
        return infos;
      }
 
    /**
     * Delete a participant
     * Delete the generated participant id for the given session
     * Delet it from the localstorage
     */
    deleteForSession = (sessionId) => {
        this._del(sessionId)
        return (null)
    }

    /**
     * Get participant for given session id
     * Retrieve the value stored in the localstorage for the given key (session id)
     */
    getBySessionId = (sessionId) => this._get(sessionId);
    getParticipantIdBySessionId = (sessionId) => this.getBySessionId(sessionId).id;

    getVoteForSequence = (results, sequenceId, participantId) => {
        if (results[sequenceId] != null && results[sequenceId][participantId] != null)
            return (results[sequenceId][participantId]);
        return (null);
    }
    hasVotedForSequence = (results, sequenceId, participantId) => this.getVoteForSequence(results, sequenceId, participantId) !== null;
}

export default new ParticipantService();